import { Link } from "wouter";

const FEATURES = [
  {
    title: "Experienced Engineering",
    description: "Technology professionals with real-world software development experience, not junior trainees learning on your project.",
  },
  {
    title: "Flexible Engagement",
    description: "Start with one developer or a full team, and scale your engineering capacity up or down as your project requirements change.",
  },
  {
    title: "Technical Ownership",
    description: "We take responsibility from development and architecture through deployment and long-term support, not just staffing.",
  },
  {
    title: "Cost-Effective Scaling",
    description: "Expand your engineering capacity without the overhead of traditional hiring, onboarding, and benefits administration.",
  },
];

/** "Why Businesses Choose HBT Integrisys", as in the redesign mockup. */
export function WhyHBT() {
  return (
    <section id="features" className="dc" style={{ background: "#070B16", padding: "136px 0", position: "relative", overflow: "hidden" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 32px", display: "flex", flexWrap: "wrap", gap: "64px", alignItems: "flex-start" }}>
        <div style={{ flex: "1 1 380px", minWidth: "0", position: "sticky", top: "120px" }}>
          <div className="rv">
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "13px", letterSpacing: ".14em", textTransform: "uppercase", color: "#9CB0FF" }}>Why Businesses Choose HBT Integrisys</div>
            <h2 style={{ fontFamily: "Sora, sans-serif", fontWeight: "600", fontSize: "clamp(2rem, 3.8vw, 3.2rem)", letterSpacing: "-0.03em", lineHeight: "1.1", margin: "18px 0 0", color: "#fff" }}>A flexible alternative to traditional hiring.</h2>
            <p style={{ margin: "24px 0 0", fontSize: "18px", lineHeight: "1.65", color: "#A9B2C5", maxWidth: "460px" }}>We aim to become an extension of your engineering organization — not a vendor you have to manage.</p>
            <Link className="btn btn-p" href="/contact" style={{ marginTop: "36px", padding: "15px 24px", borderRadius: "999px", fontWeight: "600", fontSize: "15px" }}>Talk to Our Team <svg className="ar" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round"></path></svg></Link>
          </div>
        </div>
        <div style={{ flex: "1.3 1 520px", minWidth: "0", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "1px", background: "rgba(255,255,255,.08)", border: "1px solid rgba(255,255,255,.08)", borderRadius: "24px", overflow: "hidden" }}>
          {FEATURES.map((feature, idx) => (
            <div key={feature.title} className="wcard rv" style={{ background: "#070B16", padding: "40px", border: "1px solid transparent" }}>
              <div className="num" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "13px", color: "#6B7488" }}>{String(idx + 1).padStart(2, "0")}</div>
              <h3 style={{ fontFamily: "Sora, sans-serif", fontWeight: "600", fontSize: "22px", margin: "40px 0 0", color: "#fff" }}>{feature.title}</h3>
              <p style={{ margin: "14px 0 0", fontSize: "16px", lineHeight: "1.7", color: "#A9B2C5" }}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
